const autoNgTemplateLoaderTemplate1 = require('./nodeSelector.html');

import angular from 'angular';

import { NodeSelectorController } from './nodeSelectorController';

angular.module('portainer.agent').component('nodeSelector', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: NodeSelectorController,
  bindings: {
    model: '=',
  },
});
